module.exports = __webpack_public_path__ + "img/barriers-equipment.dca00968.png";